import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthAxios from "../../../useAuthAxios";
import LoadingDialog from '../../Loading';
import { ThemeProvider, createTheme } from '@mui/material/styles'
import InspectionDeleteDialog from "../Warranty/InspectionDeleteDialog.js"
import IconButton from '@mui/material/IconButton';
import {
    CautionButton,
} from '../../css/CSS.js';

const inspectionTheme = createTheme({
    palette: {
        background: {
            default: '#f8f7f6'
        }
    }
})

export default function UploadButtons(props) {


    const authAxios = useAuthAxios();
    const [delDialog, setDelDialog] = useState(false);
    const [activePost, setactivePost] = useState(false);
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth") };
    const navigate = useNavigate();
    const [processing, setProcessing] = useState(false);


    const onClickNPDelete = () => {
        setDelDialog(true);
    }

    const cancelClick = () => {
        setDelDialog(false);
    }

    const deleteClick = () => {
        setactivePost(true);
        setDelDialog(false);
    }


    React.useEffect(() => {
        if (processing === true) { return }

        if (activePost === true) {
            setProcessing(true);

            authAxios
                .delete('api/visitReport'
                    + "/" + props.keyData.kojiCD
                    + "/" + props.keyData.rptShubetsu
                    + "/" + props.keyData.rptSeq
                    + '/PosFile'
                    , { headers })
                .then(response => {
                    if (response.status === 200) {
                        setactivePost(false);
                        props.setPosStatus(false);
                        props.setMapLink(null)
                    } else if (response.status === 401) {
                        setProcessing(false);
                        alert("認証情報が正しくありません。");
                        navigate("/");
                    } else {
                        alert("ファイル削除に失敗しました。");
                        setactivePost(false);
                    }
                    setProcessing(false);
                }).catch(() => {
                    alert("ファイル削除に失敗しました。");
                    setactivePost(false);
                    setProcessing(false);
                });
        }
    }, [activePost]);

    return (
        <ThemeProvider theme={inspectionTheme}>
            <LoadingDialog load={processing} />
            <InspectionDeleteDialog
                contentType={0}
                name={props.posData?.fileName}
                src={"data:application;base64," + props.posData?.placeInfoFileData64}
                open={delDialog}
                cancelClick={cancelClick}
                deleteClick={deleteClick}
            />
            <CautionButton
                variant="contained"
                size="large"
                sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '18px', alignItems: "center" }}
                onClick={onClickNPDelete}
                disabled={props?.keyData?.status === 4 || !props?.keyData?.canEdit ? true : false}
            >
                <DeleteForeverIcon sx={{ mr: 2, fontSize: '2rem' }} />
                ファイル削除
            </CautionButton>
        </ThemeProvider >

    );
}



